module.exports = __webpack_public_path__ + "assets/img/saoma2.fe71e3e5.png";